import React from "react";
import { Row } from "react-bootstrap";

function Github() {
  // Generate a static 7x20 grid (140 boxes)
  const rows = 7;
  const cols = 20;
  const shades = ["#161b22", "#0e4429", "#006d32", "#26a641", "#39d353"];

  const getRandomColor = () => shades[Math.floor(Math.random() * shades.length)];

  return (
    <Row
      style={{
        justifyContent: "center",
        paddingBottom: "30px",
        color: "white",
      }}
    >
      <h1 className="project-heading" style={{ paddingBottom: "25px" }}>
        My <strong className="purple">GitHub Contributions</strong>
      </h1>
      <p
        style={{
          textAlign: "center",
          marginBottom: "25px",
          fontSize: "1.1rem",
          color: "#ddd",
        }}
      >
        Simulated contribution heatmap for portfolio display.
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${cols}, 16px)`,
          gap: "4px",
          justifyContent: "center",
        }}
      >
        {Array.from({ length: rows * cols }).map((_, index) => (
          <div
            key={index}
            style={{
              width: "16px",
              height: "16px",
              borderRadius: "2px",
              backgroundColor: getRandomColor(),
            }}
          />
        ))}
      </div>
    </Row>
  );
}

export default Github;
